//version: 20221207
import { saveObj, saveString, getString, getObj } from "./localStorage"
import { mergeObjIfExist } from "./utils"
import ImgAvatar from "src/assets/images/avatar.jpg"
import V from "src/helpers/V"
import { HCF } from "@macashipo/mlib"
import { KConfigApp } from "src/helpers/K"
import { KAuth } from "src/helpers/Flows/Auth"
import HI18 from "./i18n"
const AuthInfo: any = {
  kAuthToken: "Auth-Token",
  kAuthType: "Auth-Type",
  kAuthInfo: "Auth-Info",
  kAuthInfoSocial: "Auth-InfoSocial",
  token: "",
  type: "Bearer",
  info: {},
  infoSocial: null,
  info2FA: {},
  checkBeforeLogout: {},
  listAfterLogout: {},
  listAfterLogin: {},
}

const AuthConfig: IAuthConfig = {
  afterLogout: () => {},
  afterLogin: () => {},
}

export const initAuth = (config?: IAuthConfig) => {
  mergeObjIfExist(AuthConfig, config)
  loadLastSaved()
  HCF.setCF(KAuth.fnUpdateAuthInfo, authInfo => {
    console.log("update AuthInfo", authInfo)
    if (authInfo) {
      AuthInfo.info = Object.assign(AuthInfo.info, authInfo)
    }
  })
}
export const authCheckSavedAuthorized = () => {
  let _token = getString(AuthInfo.kAuthToken, "")
  if (_token) {
    return true
  }
  return false
}

export const authGetAuthorizationHeader = () => {
  // console.warn("authGetAuthorizationHeader:", AuthInfo)
  if (AuthInfo.token) {
    return `${AuthInfo.type} ${AuthInfo.token}`
  }
}

export const registerCheckBeforeLogout = (key, fn) => {
  if (key) {
    if (fn) {
      AuthInfo.checkBeforeLogout[key] = fn
    } else {
      delete AuthInfo.checkBeforeLogout[key]
    }
  }
}
export const registerAfterLogout = (key, fn) => {
  if (key) {
    if (fn) {
      AuthInfo.listAfterLogout[key] = fn
    } else {
      delete AuthInfo.listAfterLogout[key]
    }
  }
}
export const registerAfterLogin = (key, fn) => {
  if (key) {
    if (fn) {
      AuthInfo.listAfterLogin[key] = fn
    } else {
      delete AuthInfo.listAfterLogin[key]
    }
  }
}
export const checkBeforeLogout = () => {
  if (AuthInfo.checkBeforeLogout) {
    for (let k of Object.keys(AuthInfo.checkBeforeLogout)) {
      let _fn = AuthInfo.checkBeforeLogout[k]
      if (_fn) {
        let _check = _fn()
        if (_check === false) {
          return false
        }
      }
    }
  }
  return true
}

const loadLastSaved = () => {
  // AuthInfo.auth = data;
  let _obj = {
    type: getString(AuthInfo.kAuthType, AuthInfo.type),
    token: getString(AuthInfo.kAuthToken, ""),
    info: getObj(AuthInfo.kAuthInfo, {}),
  }
  if (_obj.token) {
    authLogin(_obj)
  }
}
const savedLocal = () => {
  saveString(AuthInfo.kAuthType, AuthInfo.type)
  saveString(AuthInfo.kAuthToken, AuthInfo.token)
  saveObj(AuthInfo.kAuthInfo, AuthInfo.info)
  HCF.setCF(KConfigApp.AuthInfo, AuthInfo.info)
  V.Auth_ParseAuthInfo(AuthInfo.info)
}

export const authLogin = (data: IAuth) => {
  mergeObjIfExist(AuthInfo, data)
  savedLocal()
  // console.warn("authLogin:", data)
  afterLogin()
}

const getInfoFromData = function (data: any) {
  let _info = {}
  for (let k of Object.keys(data)) {
    if (k !== "access_token" && k !== "token_type") {
      _info[k] = data[k]
    }
  }
  return _info
}
const parse2FAfromData = function (data: any) {
  if (data) {
    AuthInfo.info2FA["fa2_needenable"] = data.fa2_needenable
    AuthInfo.info2FA["fa2_needverify"] = data.fa2_needverify
    AuthInfo.info2FA["fa2_token"] = data.fa2_token
    AuthInfo.info2FA["user_uniqueid"] = data.user_uniqueid
    AuthInfo.info2FA["user_id"] = data.user_id
    AuthInfo.info2FA["fa2_method"] = data.fa2_method
  }
}
export const authLoginWithRes = (data: any): boolean => {
  console.warn("authLoginWithRes:", data)
  parse2FAfromData(data)
  console.warn("AuthInfo.info2FA:", AuthInfo.info2FA)
  if (data && data.access_token) {
    let _info = getInfoFromData(data)
    let _obj = {
      token: data.access_token,
      type: data.token_type,
      info: _info,
    }
    if (_info["language_code"]) {
      HI18.changeLanguage(_info["language_code"], true)
    }
    authLogin(_obj)
    return true
  }
  return false
}
export const authLoginSocialWithRes = (data: any): boolean => {
  if (data) {
    if (data.Token) {
      parse2FAfromData(data.Token)
    }
    if (data.Token && data.Token.access_token) {
      let _info = getInfoFromData(data.Token)
      let _obj = {
        token: data.Token.access_token,
        type: data.Token.token_type,
        info: _info,
        infoSocial: data.SocialInfo,
      }
      authLogin(_obj)
      return true
    }
  }
  return false
}

export const authLogoutWithNothing = () => {
  localStorage.removeItem(AuthInfo.kAuthToken)
  localStorage.removeItem(AuthInfo.kAuthInfo)
  localStorage.removeItem(AuthInfo.kAuthType)
  AuthInfo.info2FA = {}
  AuthInfo.info = {}
  AuthInfo.token = ""
  //remove all config with prefix Auth
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (key && key.startsWith("Auth-")) {
      localStorage.removeItem(key)
    }
  }
}

const afterLogout = () => {
  if (AuthConfig.afterLogout) {
    AuthConfig.afterLogout()
  }
  if (AuthInfo.listAfterLogout) {
    for (let k of Object.keys(AuthInfo.listAfterLogout)) {
      let _fn = AuthInfo.listAfterLogout[k]
      if (_fn) {
        _fn()
      }
    }
  }
}
const afterLogin = () => {
  if (AuthConfig.afterLogin) {
    AuthConfig.afterLogin()
  }
  if (AuthInfo.listAfterLogin) {
    for (let k of Object.keys(AuthInfo.listAfterLogin)) {
      let _fn = AuthInfo.listAfterLogin[k]
      if (_fn) {
        _fn()
      }
    }
  }
}

export const authLogout = () => {
  authLogoutWithNothing()
  afterLogout()
}

export const authLogoutWithReload = () => {
  authLogoutWithNothing()
  window.location.reload()
}

export const authIsLogged = () => {
  return AuthInfo.token ? true : false
}

//danh cho viec da logout, nhung login o 1 tabkhac, khi quay lai can check lai localstorage
export const authCheckLoginAgain = () => {
  var _tk = localStorage.getItem(AuthInfo.kAuthToken)
  if (_tk) {
    let _obj = {
      type: getString(AuthInfo.kAuthType, AuthInfo.type),
      token: getString(AuthInfo.kAuthToken, ""),
      info: getObj(AuthInfo.kAuthInfo, {}),
    }
    mergeObjIfExist(AuthInfo, _obj)
  }
  return AuthInfo.token ? true : false
}

export const getUserInfo = (): any => {
  return AuthInfo.info
}

export const getInfo2FA = () => {
  return AuthInfo.info2FA
}

export const getAuthToken = () => {
  return AuthInfo.token
}

export const getUserID = () => {
  return getUserInfo()?.user_id
}

export const getUserName = () => {
  return getUserInfo()?.name
}

export const getUserEmail = () => {
  return getUserInfo()?.user_name
}

export const getUserAvatar = () => {
  if (getUserInfo() && getUserInfo()["avatar_url"]) {
    return getUserInfo()?.avatar_url
  }
  return ImgAvatar
}

export const getUserLogoApp = () => {
  return getUserInfo()?.appLogo_url
}

export const checkShow2FAFromTokenResponse = resToken => {
  if (resToken) {
    if (resToken.fa2_needenable || resToken.fa2_needverify) {
      return true
    }
  }
  return false
}

export const getUserExt = (key = "") => {
  let _data = getObj("Auth-UserExt", {})
  if (key && _data) {
    if (key == "*") {
      return _data
    }
    return _data[key]
  }
}

export const setUserExt = (obj = {}) => {
  let _dataSave = obj
  if (Array.isArray(obj)) {
    _dataSave = {}
    obj.forEach((v, i) => {
      _dataSave[v.Key] = v.Value
      if (v.Value === "True") {
        _dataSave[v.Key] = true
      } else if (v.Value === "False") {
        _dataSave[v.Key] = false
      }
    })
  }
  saveObj("Auth-UserExt", _dataSave)
}

export const updateUserExt = (key, value) => {
  let _data = getObj("Auth-UserExt", {})
  // console.log("updateUserExt:", key, value, _data)
  if (key) {
    _data[key] = value
    saveObj("Auth-UserExt", _data)
  }
}
